import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function InstitutionPartner() {
  const [partners, setPartners] = useState([])
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [selectedPartner, setSelectedPartner] = useState(null)
  const [form, setForm] = useState({ name: '', phone: '', level: '普通', commission_rate: 20, institution_count: 0 })

  useEffect(() => { loadPartners() }, [])

  const loadPartners = () => {
    setLoading(true)
    fetch(`${API}/partners/institution`)
      .then(r => r.json())
      .then(d => { if (d.success) setPartners(d.data || []) })
      .catch(() => {
        setPartners([
          { id: 'IP001', name: '张三', phone: '138****8001', level: '高级', commission_rate: 25, institutions: 5, commission: 15800, status: 'active' },
          { id: 'IP002', name: '李四', phone: '138****8002', level: '普通', commission_rate: 20, institutions: 3, commission: 8900, status: 'active' },
        ])
      })
      .finally(() => setLoading(false))
  }

  const openAdd = () => {
    setSelectedPartner(null)
    setForm({ name: '', phone: '', level: '普通', commission_rate: 20, institution_count: 0 })
    setShowModal(true)
  }

  const openEdit = (p) => {
    setSelectedPartner(p)
    setForm({ name: p.name, phone: p.phone, level: p.level, commission_rate: p.commission_rate, institution_count: p.institutions || 0 })
    setShowModal(true)
  }

  const handleSave = () => {
    if (!form.name || !form.phone) { alert('请填写姓名和手机号'); return }
    if (selectedPartner) {
      setPartners(prev => prev.map(p => p.id === selectedPartner.id ? { ...p, ...form } : p))
      alert('合伙人已更新')
    } else {
      setPartners(prev => [...prev, { id: 'IP' + Date.now(), ...form, institutions: 0, commission: 0, status: 'active' }])
      alert('合伙人已添加')
    }
    setShowModal(false)
  }

  const handleDelete = (p) => {
    if (!confirm(`确定删除合伙人 "${p.name}" 吗？`)) return
    setPartners(prev => prev.filter(x => x.id !== p.id))
    alert('已删除')
  }

  const resetPassword = (p) => {
    if (!confirm(`确定重置 ${p.name} 的密码？`)) return
    const tempPwd = Math.random().toString(36).slice(-8)
    alert(`新密码：${tempPwd}\n请告知合伙人并提醒修改密码`)
  }

  const toggleStatus = (p) => {
    const newStatus = p.status === 'active' ? 'disabled' : 'active'
    if (!confirm(`确定${newStatus === 'active' ? '启用' : '禁用'}合伙人 ${p.name}？`)) return
    setPartners(prev => prev.map(x => x.id === p.id ? { ...x, status: newStatus } : x))
    alert('状态已更新')
  }

  const getLevelBadge = (level) => {
    const colors = { '高级': '#fa8c16', '金牌': '#faad14', '普通': '#52c41a' }
    return <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: colors[level] || '#999', color: '#fff' }}>{level}</span>
  }

  const totalCommission = partners.reduce((s, p) => s + (p.commission || 0), 0)

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ fontSize: 20, marginBottom: 4 }}>🤝 机构合伙人</h2>
          <p style={{ color: '#666', fontSize: 13 }}>管理机构级别合伙人，推荐机构和门店加盟</p>
        </div>
        <button onClick={openAdd} style={{ padding: '10px 20px', background: '#722ed1', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 'bold' }}>
          + 添加合伙人
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>合伙人总数</div><div style={{ fontSize: 28, color: '#1890ff' }}>{partners.length}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>推荐机构</div><div style={{ fontSize: 28, color: '#52c41a' }}>{partners.reduce((s, p) => s + (p.institutions || 0), 0)}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>累计佣金</div><div style={{ fontSize: 28, color: '#fa8c16' }}>¥{totalCommission.toLocaleString()}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>待结算</div><div style={{ fontSize: 28, color: '#eb2f96' }}>¥{(totalCommission * 0.1).toLocaleString()}</div></div>
      </div>

      {/* 添加/编辑弹窗 */}
      {showModal && (
        <div style={{ background: '#fff', borderRadius: 8, padding: 24, marginBottom: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <h3 style={{ marginBottom: 16 }}>{selectedPartner ? '编辑机构合伙人' : '添加机构合伙人'}</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12 }}>
            <input type="text" placeholder="姓名" value={form.name} onChange={e => setForm({...form, name: e.target.value})} style={input} />
            <input type="text" placeholder="手机号" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} style={input} />
            <select value={form.level} onChange={e => setForm({...form, level: e.target.value})} style={input}>
              <option value="普通">普通合伙人</option>
              <option value="高级">高级合伙人</option>
              <option value="金牌">金牌合伙人</option>
            </select>
            <input type="number" placeholder="佣金比例 %" value={form.commission_rate} onChange={e => setForm({...form, commission_rate: parseInt(e.target.value)})} style={input} />
          </div>
          <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
            <button onClick={handleSave} style={{ padding: '10px 24px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>保存</button>
            <button onClick={() => setShowModal(false)} style={{ padding: '10px 24px', background: '#999', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>取消</button>
          </div>
        </div>
      )}

      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              {['编号', '姓名', '手机', '级别', '佣金比例', '推荐机构', '累计佣金', '状态', '操作'].map(h => (
                <th key={h} style={th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {partners.map(p => (
              <tr key={p.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={td}>{p.id}</td>
                <td style={{ ...td, fontWeight: 600 }}>{p.name}</td>
                <td style={{ ...td, color: '#666' }}>{p.phone}</td>
                <td style={td}>{getLevelBadge(p.level)}</td>
                <td style={{ ...td, color: '#52c41a' }}>{p.commission_rate || p.commissionRate || 20}%</td>
                <td style={{ ...td, color: '#1890ff' }}>{p.institutions || 0}</td>
                <td style={{ ...td, color: '#f5222d', fontWeight: 600 }}>¥{(p.commission || 0).toLocaleString()}</td>
                <td style={td}>
                  <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: p.status === 'active' ? '#f6ffed' : '#fff1f0', color: p.status === 'active' ? '#52c41a' : '#ff4d4f' }}>
                    {p.status === 'active' ? '活跃' : '已禁用'}
                  </span>
                </td>
                <td style={td}>
                  <button onClick={() => openEdit(p)} style={{ ...btn, background: '#1890ff', color: '#fff' }}>编辑</button>
                  <button onClick={() => resetPassword(p)} style={{ ...btn, background: '#faad14', color: '#fff', marginLeft: 4 }}>重置密码</button>
                  <button onClick={() => toggleStatus(p)} style={{ ...btn, background: p.status === 'active' ? '#ff4d4f' : '#52c41a', color: '#fff', marginLeft: 4 }}>{p.status === 'active' ? '禁用' : '启用'}</button>
                  <button onClick={() => handleDelete(p)} style={{ ...btn, background: '#8c8c8c', color: '#fff', marginLeft: 4 }}>删除</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
const card = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }
const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
const btn = { padding: '4px 8px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }
const input = { padding: 10, borderRadius: 6, border: '1px solid #ddd' }
